import { React, useState, useEffect } from "react";
import "./HomeContent.css";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { updateLoginUserName } from "../Redux/BussinessPOCSlice";
function HomeContent() {
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const dispatch = useDispatch();

 useEffect(() => {
  if (activeAccount) {
   //    setuserName(activeAccount.idTokenClaims.enterpriseID);
   //    console.log(
   //     "activeAccount.idTokenClaims.enterpriseID",
   //     activeAccount.idTokenClaims.enterpriseID
   //    );
   dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
  } else {
   dispatch(updateLoginUserName(null));
  }
 }, [activeAccount]);
 return (
  <>
   <div className="banner">
    <img
     src={process.env.PUBLIC_URL + "/images/Home/home-banner.png"}
     alt="banner"
     className="home-banner"
    />
    <h1 className="banner-content">Training Nomination Request Tool</h1>
   </div>
   <div className="about_section">
    <h3 className="about_header">About</h3>
    <p className="about_para">
     At LKM, we provide support in planning and executing training for ATCI employees.
     Some Training programs requires business teams to provide the nominations instead of
     allowing employees to self-nominate. This “Training nomination Request tool” allows
     the business teams to review the scheduled training sessions, upload the training
     nominations for a specific Training session and view their nomination status as and
     when required. The tool also allows the SMEs to review the nominees profile and
     approve/reject the nomination. It also allows the admin team to select nomination on
     FIFO basis.
    </p>
   </div>
   <div className="course_section">
    <Link to="/sessionDetailsToNominate">
     <div className="course_card">
      <img
       src={process.env.PUBLIC_URL + "/images/Home/SAP img.png"}
       alt="course"
       className="course_img"
      />
      <div className="course_content">
       <h3 className="course_header">SAP</h3>
       <p>
        This section of the tool allows the Business teams within ATCI to upload the
        Trainee nominations for the scheduled training sessions, view their nomination
        status.
       </p>
      </div>
     </div>
    </Link>
    {/* <div className="course_card">
     <img
      src={process.env.PUBLIC_URL + "/images/Home/Java img.png"}
      alt="course"
      className="course_img"
     />
    </div> */}
   </div>
  </>
 );
}

export default HomeContent;
